import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import Footer from "../components/Footer";
import LeftSVG from "../assets/page_svg/vector.svg";
import RightSVG from "../assets/page_svg/faq.svg";
import WhatsAppButton from "../components/WhatsappButton";

const FAQ: React.FC = () => {
  const { t } = useLanguage();
  // Get FAQ data for the current language
  const faqItems = [
    {
      question: t("faq.openingHours"),
      answer: t("faq.openingHoursAnswer"),
    },
    {
      question: t("faq.ageGroups"),
      answer: t("faq.ageGroupsAnswer"),
    },
    {
      question: t("faq.meals"),
      answer: t("faq.mealsAnswer"),
    },
    {
      question: t("faq.scheduleVisit"),
      answer: t("faq.scheduleVisitAnswer"),
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F9DCAC" }}>
      <div className="relative z-10">
        {/* Hero Section */}
        <section className="relative  py-20 px-4 sm:px-6 lg:px-8 hero-section-h">
          {/* Decorative SVGs (scaled with container) */}
          <div className="absolute inset-0 pointer-events-none z-0">
            {/* Left SVG */}
            <img
              src={LeftSVG}
              alt="left decoration"
              className="absolute top-0 left-0 max-w-[150px] sm:max-w-[220px] md:max-w-[250px] lg:max-w-[280px] w-full opacity-100"
            />
            {/* Right SVG */}
            <img
              src={RightSVG}
              alt="right decoration"
              className="absolute bottom-[-50px] right-0 max-w-[210px] sm:max-w-[230px] md:max-w-[270px] lg:max-w-[320px] w-full opacity-100"
            />
          </div>
          <div className="max-w-6xl mx-auto text-center z-10 relative">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-child font-semibold text-black mb-6">
              {t("common.faq")}
            </h1>
            <p className="text-xl md:text-2xl text-neutral-800 max-w-3xl mx-auto leading-relaxed">
              {t("common.faqDescription")}
            </p>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              {faqItems.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft "
                >
                  <h3 className="text-xl font-child font-semibold text-neutral-800 mb-4">
                    {item.question}
                  </h3>
                  <p className="text-neutral-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* WhatsApp Floating Contact Button */}
      <WhatsAppButton />
      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default FAQ;
